import { MijnRoute } from '../../mijn-navigatie.model';

export const MORTGAGE_OVERVIEW_DETAILS: MijnRoute = {
    path: 'details',
    navigationEvent: 'toHypotheekDetails',
    regex: /^\/hypotheek\/details$/,
    webcomponent: 'mijn-hypotheken-home-webcomponent',
    internalPath: '/details'
};
